<template lang="pug">

	.product-purchasing.h-full
		template(v-if="currentProduct")
			.product-detail
				.content-inner.p-1
					p(v-if="currentProduct.variants[0].sku") [{{ currentProduct.variants[0].sku }}]
					p "{{ currentProduct.title }}"
					p {{ currentProduct.shortDescription }}
					p [Details]
					p(v-html="currentProduct.descriptionHtml")

					//- template(v-for="(option, index) in currentProduct.options")
					//- 	div
					//- 		template(v-for="(value, index) in option.values")
					//- 			span {{ value.value }}
					//- 			span(v-if="index + 1 < option.values.length") &nbsp;/&nbsp;
					p &copy;{{ currentYear() }}

					.purchasing-info.mt-1(v-bind:class="{ 'line-through' : !currentProduct.variants[selectedVariantIndex].available }")
						p ${{ currentProduct.variants[selectedVariantIndex].price.amount }} (Inc 10% GST)

						//- AFTERPAY ONCE APPROVED AND ENABLED
						//- p.text-darkgrey.mt-025 Or 4 payments of {{ afterPaySplit() }} with
						//- 	span.inline-block.px-05.py-015.rounded-full.bg-afterpay.font-bold.mr-05.text-black AfterPay
						//- 	a.underline(href="https://www.afterpay.com.au" target="_blank") More Info

				

				div.relative(v-for="(option, opt_index) in currentProduct.options" v-if="productHasOptions()")
					.border-t-2.border-blue.text-center.py-015.text-black {{ option.name }}:
					.border-t-2.border-r.border-blue.text-center.text-black.flex.justify-center.bg-lightgrey.relative.w-full.cursor-pointer(class="hover:bg-blue hover:text-white")
						select.bg-transparent.appearance-none.w-full.text-center.py-015.cursor-pointer.opacity-100.uppercase(@change="selectOption($event, opt_index)")
							option(
								v-for="(value, val_index) in option.values"
								:value="val_index"
								v-bind:selected="val_index == selectedOptions[opt_index]"
								) {{ value.value }}

						//- select.bg-transparent.appearance-none.w-full.text-center.py-015.cursor-pointer.opacity-0(v-model="selectedVariantIndex")
						//- 	option(v-for="(variant, index) in currentProduct.variants" v-bind:value="index") {{ variant.title }}
						//- .selected-item.pointer-events-none.w-full.absolute.inset-0.flex.justify-center.items-center {{ currentProduct.variants[selectedVariantIndex].title }}

						i.fal.fa-chevron-down.absolute.right-0.top-0.bottom-0.flex.items-center.pointer-events-none.px-1.justify-center
				.border-t-2.border-r.border-blue.text-black.bg-darkgrey.flex.justify-center
					span.px-1.py-015.flex.items-center.border-blue.border-l-2.cursor-pointer(@click="decreaseQuantity()" class="hover:bg-blue hover:text-white") -
					span.px-1.py-015.flex.items-center.border-blue.border-l-2.border-r-2 {{ qty }}
					span.px-1.py-015.flex.items-center.border-blue.border-r-2.cursor-pointer(@click="increaseQuantity()" class="hover:bg-blue hover:text-white") +
				.border-t-2.border-blue.text-center.py-015.text-black(v-bind:class="{ 'line-through' : !currentProduct.variants[selectedVariantIndex].available }") ${{ currentProduct.variants[selectedVariantIndex].price.amount }}

				template(v-if="currentProduct.variants[selectedVariantIndex].available")
					template(v-if="!onHold")
						.bg-blue.text-white.text-center.py-015.cursor-pointer(class="hover:bg-red")
							template(v-if="state.updatingCart")
								i.fas.fa-asterisk.fast-spin
							template(v-else)
								span.font-bold(@click="addToCart()") Add To Cart
					template(v-else)
						.bg-red.text-white.text-center.py-015.cursor-not-allowed On Hold
				template(v-else)
					.bg-red.text-white.text-center.py-015.cursor-not-allowed Sold Out

				//- .content-inner.p-1.border-b-2
				//- 	p [Details]
				//- 	p(v-html="currentProduct.descriptionHtml")

		template(v-else)
			.loading-product.flex.justify-center.items-center.flex-1.h-full
				i.fas.fa-asterisk.fast-spin.text-lg
				
</template>

<script>
import { store, client } from "./../shopify/store.js";

export default {
	name: 'AddToCart',
	data() {
		return {
			productHandle: null,
			onHold: false,
			currentProduct: null,
			qty: 1,
			state: store.state,
			shortDescription: '',
			allOptions: [],
			selectedVariantIndex: 0,
			selectedOptions: [],
			selectedVariantId: false,
			loading: true,
			base_url: window.location.href.split('?')[0],
		}
	},
	methods: {
		selectOption(event, opt_index) {
			this.selectedOptions.splice(opt_index, 1, parseInt(event.target.value))
			this.$nextTick(() => {
				history.pushState({}, "", `${this.base_url}?variant=${this.selectedVariantId}`)
			})
		},
		productHasOptions() {
			return this.allOptions.find(option => option.name != 'Title')
		},
		determineVariantID() {
			if (!this.variants || !this.currentProduct) return;

			let variant = this.variants.find(variant => {
				if (!variant.selectedOptions) return false;
				
				let match = true;
				for(let i = 0; i < this.currentProduct.options.length; i++) {
					const optionValue = this.currentProduct.options[i].values[this.selectedOptions[i]];
					if (!optionValue || optionValue.value !== variant.selectedOptions[i].value) {
						match = false;
						break;
					}
				}
				return match;
			});

			if (variant) {
				console.log('found this variant: ', variant.title);
				this.selectedVariantId = variant.id;
			} else {
				console.log('No matching variant found');
				// Fallback to first variant if no match found
				this.selectedVariantId = this.variants[0]?.id;
			}
		},
		increaseQuantity() {
			const currentVariant = this.variants[this.selectedVariantIndex];
			const maxAvailable = currentVariant?.quantityAvailable || 0;
			
			if (this.qty < 99) {
				if (maxAvailable > 0 && this.qty >= maxAvailable) {
					store.noty('error', `Only ${maxAvailable} item${maxAvailable > 1 ? 's' : ''} available`);
					this.qty = maxAvailable;
				} else {
					this.qty++;
				}
			}
		},
		decreaseQuantity() {
			if (this.qty > 1) {
				this.qty--
			}
		},
		async addToCart() {
			try {
				const currentVariant = this.variants[this.selectedVariantIndex];
				const maxAvailable = currentVariant?.quantityAvailable || 0;

				if (maxAvailable > 0 && this.qty > maxAvailable) {
					store.noty('error', `Only ${maxAvailable} item${maxAvailable > 1 ? 's' : ''} available`);
					this.qty = maxAvailable;
					return;
				}

				await store.addLineItem(this.selectedVariantId, this.qty);
				// Reset quantity after successful add
				this.qty = 1;
			} catch (error) {
				console.error('Error adding to cart:', error);
			}
		},
		currentYear() {
			var d = new Date();
 			return d.getFullYear();
		},
		afterPaySplit() {
			return store.helpers.moneyFormat(this.currentProduct.variants[this.selectedVariantIndex].price / 4)
		}
	},
	computed: {
		variants() {
			if (!this.currentProduct?.variants) return [];
			return this.currentProduct.variants;
		},
		variantsOptions() {
			if (!this.variants.length) return {};
			let values = {};
			this.variants.forEach(variant => {
				if (variant.id && variant.selectedOptions) {
					values[variant.id] = variant.selectedOptions;
				}
			});
			return values;
		},
		selectedVariant() {
			if (!this.selectedVariantId || !this.variants.length) return {};
			return this.variants.find(variant => variant.id === this.selectedVariantId) || {};
		},
		selectedVariantCompareAtPrice() {
			if (!this.selectedVariant?.compareAtPrice?.amount) return null;
			return store.helpers.moneyFormat(this.selectedVariant.compareAtPrice.amount);
		},
		selectedVariantPrice() {
			if (!this.selectedVariant?.price?.amount) return null;
			return store.helpers.moneyFormat(this.selectedVariant.price.amount);
		}
	},
	watch: {
		selectedOptions: {
			deep: true,
			handler(options) {
				this.determineVariantID();
			}
		},
		'state.cart': {
			deep: true,
			handler(newCart) {
				// Update local state when cart changes
				if (newCart) {
					this.cartLoaded = true;
				}
			}
		}
	},
	beforeMount() {
		this.productHandle = this.$el.attributes['data-product-handle'].value
		this.shortDescription = this.$el.attributes['data-short-description'].value

		if(this.$el.attributes['data-on-hold'].value) {
			this.onHold = true
		}

		const fetchProduct = async () => {
			try {
				const query = `
					query GetProduct($handle: String!) {
						product(handle: $handle) {
							id
							title
							handle
							descriptionHtml
							options {
								id
								name
								values
							}
							variants(first: 100) {
								edges {
									node {
										id
										title
										sku
										availableForSale
										quantityAvailable
										selectedOptions {
											name
											value
										}
										price {
											amount
											currencyCode
										}
										compareAtPrice {
											amount
											currencyCode
										}
									}
								}
							}
						}
					}
				`;

				const response = await store.makeStorefrontRequest(query, { handle: this.productHandle });

				if (response?.data?.product) {
					// Transform the response to match the expected format
					const product = response.data.product;
					this.currentProduct = {
						...product,
						variants: product.variants.edges.map(edge => ({
							id: edge.node.id,
							title: edge.node.title,
							sku: edge.node.sku,
							available: edge.node.availableForSale,
							quantityAvailable: edge.node.quantityAvailable,
							selectedOptions: edge.node.selectedOptions,
							price: edge.node.price,
							compareAtPrice: edge.node.compareAtPrice
						}))
					};

					this.allOptions = product.options.map(option => ({
						...option,
						values: option.values.map(value => ({ value }))
					}));

					// inject selected variant ID from URL or fallback to Shopify data
					const urlParams = new URLSearchParams(window.location.search);
					const urlVariant = urlParams.get('variant');
					this.selectedVariantId = (urlVariant !== null) ? urlVariant : this.currentProduct.variants[0].id;

					let initialOptions = [];
					if(Object.keys(this.selectedVariant).length) {
						this.selectedVariant.selectedOptions.forEach((option, i) => {
							initialOptions[i] = this.allOptions[i].values.findIndex(e => e.value == option.value);
						});
						this.selectedOptions = initialOptions;
					} else {
						for(let i = 0; i < this.currentProduct.options.length; i++) {
							initialOptions.push(0); // fallback: set all defaults to first array key
						}
						this.selectedOptions = initialOptions;
					}

					this.loading = false;
				} else {
					throw new Error('Product not found');
				}
			} catch (error) {
				console.error('Error fetching product:', error);
				store.noty('error', 'Unable to Fetch Product');
			}
		};

		fetchProduct();
	},
	mounted() {
		
	}
};
</script>
